import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DatePickerField from 'components/application/DatePickerField';
import TextArea from 'components/application/TextArea';

export default function BookingDetailsForm({
  currentBooking,
  dateLabel,
  onDateChange,
  onInputChange,
  removeErrorStyling,
  requestError,
}) {
  const { t: i18nTBookings } = useTranslation('common', {
    keyPrefix: 'bookings',
  });

  return (
    <div className='form-container'>
      <div className='tw-flex tw-justify-start'>
        <div className='tw-mr-3'>
          <DatePickerField
            earliestDate={new Date()}
            fieldError={requestError.validationErrors.date}
            label={dateLabel}
            name='date'
            onChange={onDateChange}
            removeErrorStyling={removeErrorStyling}
            value={currentBooking.date}
          />
        </div>
      </div>
      <TextArea
        label={i18nTBookings('bookingNotes')}
        name='notes'
        onChange={onInputChange}
        tooltip={i18nTBookings('bookingNotesAreIncludedInTheEmail')}
        value={currentBooking.notes}
      />
    </div>
  );
}

BookingDetailsForm.propTypes = {
  currentBooking: PropTypes.shape({
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    notes: PropTypes.string,
    personnelIds: PropTypes.array,
  }).isRequired,
  dateLabel: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  removeErrorStyling: PropTypes.func,
  requestError: PropTypes.object,
};
